import { EmailBox } from '@apply/components';
import { useCustomPaymentEmail } from '../../../fields/CustomPaymentFields';

interface EmailAddressProps {
    customPaymentId: string;
    required?: boolean;
}

export const EmailAddress: React.FC<EmailAddressProps> = ({ customPaymentId, required = false }) => {
    const label = 'Email Address ';
    const [email, set_email] = useCustomPaymentEmail(customPaymentId);

    return (
        <EmailBox
            value={email}
            onChange={(value) => set_email(value)}
            label={label}
            required={required}
            width='100%'
        />
    );
};
